import { msg } from '@lingui/macro';

export const LOCATION_DEFAULT_TITLE_1 = msg`Address`;
export const LOCATION_DEFAULT_PLACEHOLDER = msg`Add your address`;
export const LOCATION_DEFAULT_PLACEHOLDER_VARIANT = msg`Add address`;
export const LOCATION_DEFAULT_TITLE_2 = msg`What's your address?`;
export const LOCATION_FOOTER_LABEL = msg`Add dates and an address to see sitters who’ll be available for your need.`;
